 

"use client";

import React from "react";
import parse from "html-react-parser";
import he from "he";

// Component imports
import { Rating as ReactRating, StickerStar } from "@smastrom/react-rating";
import Pagination from '@/components/pagination';
import Loader from '@/components/loader';

// Styles imports
import "@smastrom/react-rating/style.css";
import styles from "./reviews.module.scss";
import { ProductReviews } from "@/lib/types/productReviews";

// Define the prop types
interface ReviewsProps {
  isLoading: boolean;
  reviewsData: ProductReviews;
  page: number;
}

const ratingStyles = {
  itemShapes: StickerStar,
  activeFillColor: "#dc181f",
  inactiveFillColor: "#ffffff",
  itemStrokeWidth: 1,
};

export function Reviews({ isLoading, reviewsData, page }: ReviewsProps) {
  return (
    <div className={styles.wrapper}>
      <h1>REVIEWS</h1>

      <div className={styles.content}>
        {isLoading && (
          <div className={styles.loader}>
            <Loader variant="2" />
          </div>
        )}

        {!isLoading && reviewsData?.reviews.map((data) => (
          <div key={data.id} className={styles.review}>
            <div className={styles.grid}>
              <div className={styles.avatar}>
                <img
                  alt=""
                  src="https://secure.gravatar.com/avatar/137a0ca5735c9605c333e97be5a64426?s=60&amp;d=mm&amp;r=g"
                  srcSet="https://secure.gravatar.com/avatar/137a0ca5735c9605c333e97be5a64426?s=120&amp;d=mm&amp;r=g 2x"
                  className="avatar avatar-60 photo"
                  height="60"
                  width="60"
                  decoding="async"
                />
              </div>
              <div className={styles.details}>
                <ReactRating
                  className={styles.starWrapper}
                  value={data.rating}
                  readOnly
                  itemStyles={ratingStyles}
                />
                <p className={styles.name}>{data.author.name}</p>
                <p className={styles.date}>
                  {new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }).format(new Date(data.createdAt))}
                </p>
              </div>
            </div>
            <div className={styles.descriptions}>
              {parse(he.encode(data.comment))}
            </div>
          </div>
        ))}

        {!!reviewsData?.pagination?.totalPages && reviewsData?.pagination?.totalPages > 1 && <Pagination
          currentPage={page}
          pageCount={reviewsData?.pagination?.totalPages || 1}
        />}
      </div>
    </div>
  );
}
